module.exports = __webpack_public_path__ + "static/media/242.68181b89.wav";